// @flow
import React from 'react'
import './styles.scss'
import { Waypoint } from 'react-waypoint'
import renderHTML from 'react-render-html'

const isMobile = window.innerWidth < 600

export class Highlighter extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      overlayed: false
    }
  }

  componentDidMount() {}

  render() {
    return (
      <div
        className={
          this.state.overlayed
            ? 'highlight-wrapper overlayed'
            : 'highlight-wrapper'
        }
        style={{ marginTop: '2em' }}
      >
        <img className='ui image fluid overlay' src={this.props.overlayImage} />
        <img className='ui image fluid photo' src={this.props.baseImage} />
        {this.props.caption !== null && (
          <figcaption>
            {this.props.caption}
            <div className='source'>{this.props.source}</div>
          </figcaption>
        )}

        <Waypoint
          onEnter={event => {
            this.setState({ overlayed: true })
          }}
          onLeave={event => {
            this.setState({ overlayed: false })
          }}
        />
      </div>
    )
  }
}
